import React from 'react'

import BaseModal from '../BaseModal2'
import LoadingSpinner from '../../../atoms/LoadingSpinner'

import { getElement } from './helpers'
import useMediaHandle from '../../../../hooks/useMediaHandle'
import useStyles from './styles'

const MediaViewerModal = ({ file: media, onClose }) => {
  const {
    reset,
    startLoad,
    finishLoad,
    download,
    file,
    loading,
    isViewable,
    srcURL
  } = useMediaHandle({ media, manualEndLoad: true })

  const [elem, setElem] = React.useState(null)
  const [closing, setClosing] = React.useState(false)

  const classes = useStyles()

  // Closes the modal
  React.useEffect(() => {
    if (closing) {
      setClosing(false)
      onClose()
    }
  }, [closing, onClose])

  // Resets state
  const handleClose = React.useCallback(() => {
    setElem(null)
    setClosing(true)

    reset()
  }, [reset])

  React.useEffect(() => {
    startLoad()
  }, [startLoad])

  // Show a file or download a file that can't be shown
  React.useEffect(() => {
    if (!file) {
      return
    }

    if (!media) {
      return
    }

    if (isViewable) {
      getElement({ media, file, classes, finishLoad, url: srcURL }).then(
        elem => {
          setElem(elem)
        }
      )
    } else {
      download()
      handleClose()
    }
  }, [
    file,
    media,
    isViewable,
    classes,
    finishLoad,
    srcURL,
    download,
    handleClose
  ])

  return (
    <BaseModal
      open={isViewable}
      onClose={handleClose}
      title={media?.filename ?? 'Media'}
      PaperProps={{
        style: {
          minWidth: '10vw',
          maxWidth: '80vw',
          minHeight: '20svh',
          maxHeight: '90svh'
        }
      }}
      childrenClass={classes.childrenClass}
    >
      {loading && <LoadingSpinner className={classes.loading} />}

      {elem}
    </BaseModal>
  )
}

export default MediaViewerModal
